import { CompetencyCriteriaUniqueness } from "types/graphql-schema";

export const competencyCriteriaUniquenessLabels: {
  [key in CompetencyCriteriaUniqueness]: string;
} = {
  [CompetencyCriteriaUniqueness.SameAcrossRoles]:
    "Criteria for each level is the same across roles",
  [CompetencyCriteriaUniqueness.DifferentForEachRole]:
    "Criteria for each level is different across roles",
};

export type ImageFileAndUrl = { file: File; url: string };

export type CoreValue = {
  id?: number;
  title: string;
  description: string;
  emoji?: string | null;
  image?: string | ImageFileAndUrl | null;
};
